import React, {ReactElement} from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import BusinessServices from './BusinessServices';
import {SupplierType, ContentfulContent} from '../../../types';

interface BusinessServicesQueryProps {
  homepageTitle: string;
  homepageDescription: ContentfulContent;
  homepageCardTitle: string;
  homepageCardDescription: {
    homepageCardDescription: string;
  };
  slug: string;
  type: SupplierType;
  displayOnLocale: Locale[];
  node_locale: Locale;
}

function BusinessServicesWithQuery(): ReactElement {
  const locale = useLocale();

  const {allContentfulSupplier: queryData} = useStaticQuery(
    graphql`
      query Supplier {
        allContentfulSupplier(filter: {shouldShowOnHomePage: {eq: true}}) {
          nodes {
            homepageTitle
            homepageDescription {
              raw
            }
            homepageCardTitle
            homepageCardDescription {
              homepageCardDescription
            }
            slug
            type
            displayOnLocale
            node_locale
          }
        }
      }
    `
  );

  const filteredData: BusinessServicesQueryProps = queryData.nodes.find(
    (entry: BusinessServicesQueryProps) => entry.displayOnLocale.includes(locale) && entry.node_locale === locale
  );

  if (!filteredData) {
    return <div />;
  }

  return (
    <BusinessServices
      title={filteredData.homepageTitle}
      description={filteredData.homepageDescription}
      slug={filteredData.slug}
      cardTitle={filteredData.homepageCardTitle}
      cardDescription={filteredData.homepageCardDescription.homepageCardDescription}
      type={filteredData.type}
    />
  );
}

export default BusinessServicesWithQuery;
